/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Table, Button } from 'react-bootstrap';
import DataTableFilter from "../../Common/DataTableFilter";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector,useDispatch } from "react-redux";
import GetCurrentTableSRNo from "../../Common/GetCurrentTableSRNo";
import CommonDateTime from "../../Common/CommonDateTime";
import CommonPagination from "../../Common/CommonPagination";
import { toast } from "react-toastify";
import CommonLogout from "../../Common/CommonLogout";
import ErpAFSOrderSyncRetryAPI from "../../../Api/ErpAFSOrderSyncRetryAPI";
import QuotationsStatus from "../../Common/QuotationsStatus";
import { ERP_QUOTATIONS_RETRY_API_URL } from "../../Shared/constant";
import CommonScrollBar from "../../Common/CommonScrollBar";

const AfsOrderSyncQuotationFailedReport = (props) => {
    const { OrderViewerModal, setOrderViewerModal, setLoader } = props;
    const Dispatch = useDispatch();
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("all");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ IsSpares, setIsSpares ] = useState(false);
    const { websocket } = useContext(WebSocketContext);
    const { device_id, OrderAfsOrderSycQuotationsFailedListing, accessToken, selfInfo } = useSelector((state) => state.adminReducers);
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    // api calling
    const APICall = () => {
        let param = {
            "transmit": "broadcast",
            "url": "erp_quotation_log_list",
            "request": {
                "limit": userLimit,
                "page_no": currentPage,
                "search": userSearch.trim(),
                "order_by": "-updated_at",
            },
            "DeviceId": device_id
        };
        wsSend_request(websocket, param);
    };

    // when page load api calling
    useEffect(() => {
        APICall();
    }, [ websocket, userSearch, currentPage, userLimit ]);

    // Retry ERP order
    const RtryFunction = async (data) => {
        setLoader(true);
        const formData = new FormData();
        formData.append("quotation_id", data?.id);
        const Response = await ErpAFSOrderSyncRetryAPI(ERP_QUOTATIONS_RETRY_API_URL, formData, accessToken);
        if(Response?.status === 200) {
            setLoader(false);
            APICall();
            toast.info(Response?.message);
        } else {
            setLoader(false);
            APICall();
            if(Response?.error) {
                toast.error(Response?.error);
            } else {
                toast.error(Response?.message);
            };
            if(Response?.message === "User is not authorized." && Response?.status === 400) {
                CommonLogout(accessToken, Dispatch);
                localStorage?.removeItem("access_token");
            };
        };
    };

    // error message modal open 
    const ErrorMessageShow = (data) => {
        const GetCurrentERPList = OrderAfsOrderSycQuotationsFailedListing?.erp_quotation_log_list?.filter((elm) => elm?.quotation_id === data?.id)[0];

        setOrderViewerModal({
            ...OrderViewerModal,
            open: open,
            Title: "Quotation Failed Error",
            Data: GetCurrentERPList?.response,
        });
    };
    
    return(<section className="Main_section">
        <DataTableFilter 
            searchType={"Quotation Id"}
            filterType={""}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={false}
            searchdisable={true}
            IsSpares={IsSpares} 
            setIsSpares={setIsSpares}
        />
        <div className="tableView">
            <CommonScrollBar 
                height={{ height: parseInt(OrderAfsOrderSycQuotationsFailedListing?.pagination?.total_records) === OrderAfsOrderSycQuotationsFailedListing?.list?.length ? "calc(100vh - 187px)" : parseInt(OrderAfsOrderSycQuotationsFailedListing?.pagination?.total_records) > 10 ? "calc(100vh - 221px)" : "calc(100vh - 187px)" }}
                className="ScrollbarsSidebar"
            >
                <Table>
                    <thead>
                        <tr>
                            <th>SNo</th>
                            <th>Quotation Id</th>
                            <th>Customer Code</th>
                            <th>Quotation Source</th>
                            <th>Quotation Date</th>
                            <th>Quotation Stage</th>
                            <th>Error</th>
                            {(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.AFSOrderManagement[3]?.Edit) && (<th>Action</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {OrderAfsOrderSycQuotationsFailedListing?.list?.map((elm, index) => {
                            return(<tr key={index}>
                            <td>
                                {GetCurrentTableSRNo(index, OrderAfsOrderSycQuotationsFailedListing?.pagination?.current_page, OrderAfsOrderSycQuotationsFailedListing?.pagination?.record_limit)}
                            </td>
                            <td>{elm?.quotation_code}</td>
                            <td>{elm?.customer_identity === null ? "-" : elm?.customer_identity}</td>
                            <td>{elm?.quotation_source === null ? "-" : elm?.quotation_source}</td>
                            <td>{CommonDateTime(elm?.created_at, "LL", "show")}</td>
                            <td>{QuotationsStatus(elm?.quotation_status, "badge")}</td>
                            <td>
                                <Button className="btn edittable btn btn-primary" onClick={()=> ErrorMessageShow(elm)}>
                                    <i className="bi bi-eye"></i>
                                </Button>
                            </td>
                            {(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.AFSOrderManagement[3]?.Edit) && (<td>
                                <Button className="btn edittable edittableretry btn btn-primary" onClick={() => RtryFunction(elm)}>
                                    <i className="bi bi-arrow-repeat"></i> Retry
                                </Button>
                            </td>)}
                        </tr>)})}
                        {OrderAfsOrderSycQuotationsFailedListing?.list?.length === 0 && (<tr style={{ textAlign: "center" }} ><td colSpan="10">Payment failed list not found</td></tr>)}
                    </tbody>
                </Table>
            </CommonScrollBar>
            {OrderAfsOrderSycQuotationsFailedListing?.pagination?.total_records > 10 && (<CommonPagination 
                currentPage={currentPage}
                paginationLength={OrderAfsOrderSycQuotationsFailedListing?.pagination}
                currentFunction={currentFunction}
            />)}
        </div>
    </section>)
}

export default AfsOrderSyncQuotationFailedReport;